import { createContext, useContext } from 'react';
import useFetchUserInfo from '../hooks/useFetchUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const UserInfoContext = /*#__PURE__*/createContext(undefined);
export default function UserInfoProvider({
  children
}) {
  const value = useFetchUserInfo();
  return /*#__PURE__*/_jsx(UserInfoContext.Provider, {
    value: value,
    children: children
  });
}
export function useUserInfo() {
  const context = useContext(UserInfoContext);
  if (context === undefined) {
    throw new Error('useUserInfo must be used within a UserInfoProvider');
  }
  return context;
}